import { FC, createElement } from "react";
import { WeatherTypeEnum } from "service";
/* eslint-disable */
import {
  WiFog,
  WiCloudy,
  WiHot,
  WiHail,
  WiDayWindy,
  WiDaySunny,
  WiSnowWind,
  WiDayHaze,
  WiWindy,
  WiTornado,
  WiHurricane,
  WiRain,
  WiSnow,
  WiLightning,
  WiThunderstorm,
  WiDayCloudy,
  WiDayLightning,
  WiDayRain,
  WiDaySnow,
  WiRainMix,
  // @ts-ignore
} from "weather-icons-react";
/* eslint-enable */

export const weatherTypeIconMap: Record<WeatherTypeEnum, FC> = {
  [WeatherTypeEnum.cloudy]: WiCloudy,
  [WeatherTypeEnum.fog]: WiFog,
  [WeatherTypeEnum.hail]: WiHail,
  [WeatherTypeEnum.hazy]: WiDayHaze,
  [WeatherTypeEnum.hurricane]: WiHurricane,
  [WeatherTypeEnum.lightning]: WiLightning,
  [WeatherTypeEnum.lightningRainy]: WiThunderstorm,
  [WeatherTypeEnum.partlyCloudy]: WiDayCloudy,
  [WeatherTypeEnum.partlyLightning]: WiDayLightning,
  [WeatherTypeEnum.partlyRainy]: WiDayRain,
  [WeatherTypeEnum.partlySnowy]: WiDaySnow,
  [WeatherTypeEnum.partlySnowyRainy]: WiRainMix,
  [WeatherTypeEnum.pouring]: WiRain,
  [WeatherTypeEnum.snowy]: WiSnow,
  [WeatherTypeEnum.snowyHeavy]: WiSnowWind,
  [WeatherTypeEnum.snowyRainy]: WiRainMix,
  [WeatherTypeEnum.tornado]: WiTornado,
  [WeatherTypeEnum.windy]: WiWindy,
  [WeatherTypeEnum.sunny]: WiDaySunny,
  [WeatherTypeEnum.sunnyAlert]: WiHot,
  [WeatherTypeEnum.rainy]: WiDayRain,
  [WeatherTypeEnum.windyVariant]: WiDayWindy,
  [WeatherTypeEnum.snowflake]: WiSnow,
};

const possible = Object.keys(WeatherTypeEnum);

export interface WeatherIconProps {
  type: WeatherTypeEnum;
  size?: number;
  color?: string;
}

export const WeatherIcon: FC<WeatherIconProps> = (props) => {
  const { type, size = 20, color } = props;

  if (possible.includes(type)) {
    return (
      <>
        {createElement<{ size: number; color: string | undefined }>(
          weatherTypeIconMap[type],
          { size, color },
        )}
      </>
    );
  }

  throw new Error(`Unsupported weather type ${type} for weather icon`);
};
